import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllRegProfStatuses } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/arRefProfStatuses";
const arRegProfStatusesSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(arRegProfStatusesThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(arRegProfStatusesThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(arRegProfStatusesThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const arRegProfStatusesThunk = createAsyncThunk(
  `${sliceName}/arRegProfStatusesThunk`,
  async () => {
    const response = await getAllRegProfStatuses()();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.arRegProfStatuses);
    },
  },
);

export default arRegProfStatusesSlice.reducer;
